export default "__VITE_ASSET__67c887ea__"